<div class="header">  
  <div class="instruction-block">
    <span class="tip">{{dialogInstruction}}</span>
  </div>
  <span class="title">{{dialogHeader}}</span>
  <div>
    
    <div class="icons">
      <div class="icon-holder" *ngIf="cropperEnabled$ | async">
        <mat-icon (click)="crop()"  class="tick-crop" svgIcon="tick_green"></mat-icon>
        <label class="icon-text text-success">Done</label>
      </div>
      <div class="icon-holder">
        <mat-icon (click)="undo()" class="undo-icon" svgIcon="undo"></mat-icon>
        <label class="icon-text text-warning">Undo</label>
      </div>
      
      <div class="icon-holder" *ngIf="cropperEnabled$ | async; else cropperDisabled">
        <mat-icon class="enabled-cropper " (click)="disableEditor()" svgIcon="enable_crop"></mat-icon>
        <label class="icon-text text-disable">Uncrop</label>
      </div>

      <ng-template #cropperDisabled>
        <div class="icon-holder">
          <mat-icon (click)="enableCropper()" svgIcon="disable_crop"></mat-icon>
          <label class="icon-text">Crop</label>
        </div>
      </ng-template>

      <!-- <mat-icon (click)="disableEditor()" *ngIf="rectangleRendererEnabled$ | async; else notEditable" svgIcon="create_white"></mat-icon>
      <ng-template #notEditable>
        <mat-icon (click)="enableRectangleRenderer()" svgIcon="create_black"></mat-icon>
      </ng-template> -->

    </div>
  
  </div>


</div>

<arb-pdf-editor
  *ngIf="isPdf"
  [file]="file"
  [rendererType$]="rendererType$"
  [undo$]="undo$"
  [crop$]="crop$"
  (filesChange)="onFilesChange($event)"
  (pageChanged)="onPageChanged()"
  [sideScroll]="sideScroll">
</arb-pdf-editor>

<arb-image-editor
  *ngIf="!isPdf"
  [rendererType$]="rendererType$"
  [file]="file"
  [undo$]="undo$"
  [crop$]="crop$"
  (filesChange)="onFilesChange($event)">
</arb-image-editor>

<div class="footer">
  <mat-checkbox [formControl]="agreementControl" color="primary" *ngIf="isShowAgreementControl">
    <!-- <span class="agreement-text">I certified that this document has all private information redacted.</span> -->
    <span class="agreement-text">Please ensure this document has all private information redacted.</span>
  </mat-checkbox>
  <div class="buttons">
    <button mat-dialog-close mat-flat-button (click)="cancel()">Cancel</button>
    <button
      *ngIf="isShowAgreementControl"
      [disabled]="!((allowSave$ | async) && !!files.length)"
      (click)="cancel()"
      mat-flat-button
      color="primary">
      Save
    </button>
    <button
      *ngIf="!isShowAgreementControl"  
      (click)="save()"
      mat-flat-button
      color="primary">
      Save
    </button>
  </div>
</div>
